import React, { useEffect, useState } from 'react';
import './Otp.css'; // Create this CSS file for styling
import gox from '../../assets/gox.png';
import "../Home/Home.css"
import Timer from '../../components/Date/Timer';
import { Link } from "react-router-dom"
import sms from "../../assets/sms.png"
import information from '../../assets/information.png'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { signin } from '../../action/verified';
import { emailv } from '../../action/email';
import InputBox from '../../components/InputBox';

const Otp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [gmail, setGmail]= useState()

  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(0); // State to track the timer
  const [showResendButton, setShowResendButton] = useState(false); // State to control the button visibility
  const email = useSelector((state) => state?.create)
  console.log(email?.create?.user?.email)
  
  // useEffect(() => {
  //   if (otp.join('').length === 6) {
  //     // When OTP is filled, set the timer to 60 seconds
  //     setTimer(60);
  //     // Start a countdown
  //     const countdown = setInterval(() => {
  //       setTimer((prevTimer) => prevTimer - 1);
  //     }, 1000);

  //     // Show the "Resend OTP" button after 60 seconds
  //     setTimeout(() => {
  //       setShowResendButton(true);
  //       clearInterval(countdown); // Clear the countdown interval
  //     }, 60000);
  //   }
  // }, [otp]);

  const handleOtpChange = (e, currentIndex) => {
    const value = e.target.value;

    if (/^[0-9]*$/.test(value) && currentIndex < 6) {
      setOtp((prevOtp) => {
        const newOtp = [...prevOtp];
        newOtp[currentIndex] = value;
        return newOtp;
      });

      const nextIndex = currentIndex + 1;
      if (nextIndex < 6) {
        document.getElementById(`otp-input-${nextIndex}`).focus();
      }
    }
  };

  const handleSubmit = () => {
    if (otp.join('').length === 6) {
      const otpNum = otp.join('');
      dispatch(signin(otpNum));
      console.log(otpNum)
    }

    console.log(otp.length)
  }


  const verify = useSelector((state) => state?.verify)
  

  useEffect(() => {
    if (verify?.verify?.status === "success") {
      navigate('/Employee')
    }
console.log(verify?.verify?.status)
  }, [verify])

  function handleResendOtp() {
    dispatch(emailv(email?.create?.user?.email));
    setShowResendButton(false); // Hide the button again
  }

  return (
    <div className='banner d-flex'>
      <div className="left px-5 py-5">
       
 <div className="left px-5 py-5">
            <div className='pb-5'> <h6>GOX Register</h6></div>
            <div>
                           <div className='pt-5 pb-5'>
                     <h1> <h1>Management-Focused Financial Solution</h1></h1>
                     <p>Lorem ipsum dolor sit amet consectetur. Lectus nulla sit interdum 
                         et feugiat odio. Lorem ipsum dolor sit amet consectetur. Lectus nulla sit 
                         interdum et feugiat odio.
                     </p>
                 </div>

                 <div className='dynamic p-3'>
                     <p>
                     In the dynamic landscape of modern workplaces, HR stands as the guardian of culture and the champion of employee well-being. We see our mission as not just managing resources, but as stewards of an environment 
                     where each person's unique skills and perspectives are 
                     valued.
                     </p>
                     <div className='d-flex mt-5 '>
                         <div className='mx-2'><img src={gox} alt="logo" /></div>
                         <div>
                             <h6>Gox register</h6>
                             <p>Our mission</p>
                         </div>
                     </div>
                 </div>
           
            </div>
         </div>

      </div>
      <div>
        <button type="submit" className="btn btn1 m-5 back w-50">Back</button>
      </div>
      <div className="otp-container w-100 right">
        <h1>Kindly verify your account</h1>
        <p className='justify-content-center'>An OTP code has been sent to the email you provided Dexter@gmail.com. Enter the 6-digit OTP below to verify your account</p>
        <div className="otp-input-container">
          {/* {[1, 2, 3, 4, 5, 6].map((index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={otp[index - 1]}
              onChange={(e) => handleOtpChange(e, index - 1)}
              onFocus={(e) => e.target.select()}
              id={`otp-input-${index}`}
            />
          ))} */}
          <InputBox setOtp={setOtp} otp={otp}/>
        </div>
        <div className='timer justify-content-between d-flex m-4'>
          <div className=' '>
            <Timer setShowResendButton={setShowResendButton} showResendButton={showResendButton}/>
          </div>
          <div className='d-flex mx-5'>
            <div> <img src={sms} alt="" /> </div>
            {showResendButton && <button onClick={handleResendOtp}>Resend OTP</button>}
          </div>
        </div>
        <div className='d-flex inbox'>
          <div><img src={information} alt="" /></div>
          <div>If you did not see the email in your inbox, kindly check <br /> your spam folder</div>
        </div>
        <div>
          <button className='btn btn1 w-100' onClick={handleSubmit}>Verify account</button>
        </div>
      </div>
    </div>
  );
}

export default Otp;
